// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file ai/h2o/engine/v1/sandbox_engine_image_service.proto (package ai.h2o.engine.v1, syntax proto3)
/* eslint-disable */

import type { SandboxEngineImage } from "./sandbox_engine_image_pb";
import { RPC } from "../../../../runtime";

/**
 * Request message for `CreateSandboxEngineImage`.
 *
 * @generated from message ai.h2o.engine.v1.CreateSandboxEngineImageRequest
 */
export type CreateSandboxEngineImageRequest = {
/**
 * Required. The resource name of the workspace to associate with the SandboxEngineImage.
 * Format is `workspaces/*`.
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Required. The SandboxEngineImage resource to create.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineImage sandbox_engine_image = 2;
 */
sandboxEngineImage: SandboxEngineImage;
/**
 * Optional. Specify the SandboxEngineImage ID, which will become a part of the SandboxEngineImage
 * resource name. If not specified, the server will generate one.
 *
 * It must:
 * - contain 1-63 characters
 * - contain only lowercase alphanumeric characters or hyphen ('-')
 * - start with an alphabetic character
 * - end with an alphanumeric character
 *
 * This matches a regular expression: ^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$
 *
 * @generated from field: string sandbox_engine_image_id = 3;
 */
sandboxEngineImageId?: string;
}
;
/**
 * Response message for `CreateSandboxEngineImage`.
 *
 * @generated from message ai.h2o.engine.v1.CreateSandboxEngineImageResponse
 */
export type CreateSandboxEngineImageResponse = {
/**
 * The created SandboxEngineImage.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineImage sandbox_engine_image = 1;
 */
sandboxEngineImage?: SandboxEngineImage;
}
;
/**
 * Request message for `GetSandboxEngineImage`.
 *
 * @generated from message ai.h2o.engine.v1.GetSandboxEngineImageRequest
 */
export type GetSandboxEngineImageRequest = {
/**
 * Required. The name of the SandboxEngineImage to retrieve.
 * Format is `workspaces/*\/sandboxEngineImages/*`
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for `GetSandboxEngineImage`.
 *
 * @generated from message ai.h2o.engine.v1.GetSandboxEngineImageResponse
 */
export type GetSandboxEngineImageResponse = {
/**
 * The requested SandboxEngineImage.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineImage sandbox_engine_image = 1;
 */
sandboxEngineImage?: SandboxEngineImage;
}
;
/**
 * Request message for listing SandboxEngineImages.
 *
 * @generated from message ai.h2o.engine.v1.ListSandboxEngineImagesRequest
 */
export type ListSandboxEngineImagesRequest = {
/**
 * Required. The resource name of the workspace to associate with the SandboxEngineImage.
 * Format is `workspaces/*`.
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Optional. Maximum number of SandboxEngineImages to return in a response.
 * If unspecified (or set to 0), at most 50 SandboxEngineImages will be returned.
 * The maximum value is 1000; values above 1000 will be coerced to 1000.
 *
 * @generated from field: int32 page_size = 2;
 */
pageSize?: number;
/**
 * Optional. Leave unset to receive the initial page.
 * To list any subsequent pages use the value of 'next_page_token'
 * returned from the ListSandboxEngineImagesResponse.
 *
 * @generated from field: string page_token = 3;
 */
pageToken?: string;
}
;
/**
 * Response message for ListSandboxEngineImages.
 *
 * @generated from message ai.h2o.engine.v1.ListSandboxEngineImagesResponse
 */
export type ListSandboxEngineImagesResponse = {
/**
 * Collection of SandboxEngineImages.
 *
 * @generated from field: repeated ai.h2o.engine.v1.SandboxEngineImage sandbox_engine_images = 1;
 */
sandboxEngineImages?: SandboxEngineImage[];
/**
 * Used to retrieve the next page of results.
 * When unset, no further items are available (this response was the last page).
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Request message for updating an existing SandboxEngineImage.
 *
 * @generated from message ai.h2o.engine.v1.UpdateSandboxEngineImageRequest
 */
export type UpdateSandboxEngineImageRequest = {
/**
 * Required. SandboxEngineImage resource.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineImage sandbox_engine_image = 1;
 */
sandboxEngineImage: SandboxEngineImage;
/**
 * Required. The list of paths referencing which fields to update.
 * Update mask must be non-empty.
 *
 * Allowed field paths are: {"display_name", "image", "enabled", "image_pull_policy", "image_pull_secrets"}.
 * Paths are case sensitive (must match exactly).
 *
 * To update all allowed fields, specify exactly one path with value "*".
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 10;
 */
updateMask: string;
}
;
/**
 * Response message for UpdateSandboxEngineImage.
 *
 * @generated from message ai.h2o.engine.v1.UpdateSandboxEngineImageResponse
 */
export type UpdateSandboxEngineImageResponse = {
/**
 * SandboxEngineImage resource.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineImage sandbox_engine_image = 1;
 */
sandboxEngineImage?: SandboxEngineImage;
}
;
/**
 * Request message for deleting an existing SandboxEngineImage.
 *
 * @generated from message ai.h2o.engine.v1.DeleteSandboxEngineImageRequest
 */
export type DeleteSandboxEngineImageRequest = {
/**
 * Required. SandboxEngineImage resource name.
 * Format is `workspaces/*\/sandboxEngineImages/*`.
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for DeleteSandboxEngineImage.
 *
 * @generated from message ai.h2o.engine.v1.DeleteSandboxEngineImageResponse
 */
export type DeleteSandboxEngineImageResponse = {
}
;
/**
 * Creates a new SandboxEngineImage.
 *
 * Authorization may require the following permission on the image's parent workspace:
 * * actions/enginemanager/sandboxEngineImages/CREATE
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineImageService.CreateSandboxEngineImage
 */
export const SandboxEngineImageService_CreateSandboxEngineImage = new RPC<CreateSandboxEngineImageRequest,CreateSandboxEngineImageResponse>("POST", "/v1/{parent=workspaces/*}/sandboxEngineImages", "sandboxEngineImage");
/**
 * Returns a specific SandboxEngineImage.
 *
 * Authorization may require the following permission on the image's parent workspace:
 * * actions/enginemanager/sandboxEngineImages/GET
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineImageService.GetSandboxEngineImage
 */
export const SandboxEngineImageService_GetSandboxEngineImage = new RPC<GetSandboxEngineImageRequest,GetSandboxEngineImageResponse>("GET", "/v1/{name=workspaces/*/sandboxEngineImages/*}");
/**
 * Returns a collection of SandboxEngineImages.
 *
 * Authorization may require the following permission on the image's parent workspace:
 * * actions/enginemanager/sandboxEngineImages/LIST
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineImageService.ListSandboxEngineImages
 */
export const SandboxEngineImageService_ListSandboxEngineImages = new RPC<ListSandboxEngineImagesRequest,ListSandboxEngineImagesResponse>("GET", "/v1/{parent=workspaces/*}/sandboxEngineImages");
/**
 * Updates a SandboxEngineImage.
 *
 * Authorization may require the following permission on the image's parent workspace:
 * * actions/enginemanager/sandboxEngineImages/UPDATE
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineImageService.UpdateSandboxEngineImage
 */
export const SandboxEngineImageService_UpdateSandboxEngineImage = new RPC<UpdateSandboxEngineImageRequest,UpdateSandboxEngineImageResponse>("PATCH", "/v1/{sandboxEngineImage.name=workspaces/*/sandboxEngineImages/*}", "sandboxEngineImage");
/**
 * Deletes a SandboxEngineImage.
 *
 * Authorization may require the following permission on the image's parent workspace:
 * * actions/enginemanager/sandboxEngineImages/DELETE
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineImageService.DeleteSandboxEngineImage
 */
export const SandboxEngineImageService_DeleteSandboxEngineImage = new RPC<DeleteSandboxEngineImageRequest,DeleteSandboxEngineImageResponse>("DELETE", "/v1/{name=workspaces/*/sandboxEngineImages/*}");
